import axios from "../api";

export const getSupportTicketAction = async (perPage, page, searchValue, startDate, endDate, statusFilter, amountFilter) => {
  let apiUrl = `/api/support-ticket?page=${page}&pageSize=${perPage}&status=${statusFilter}`;
  if (amountFilter !== "all") {
    apiUrl += `&amount=${amountFilter}`;
  }

  if (searchValue !== "all") {
    const encodedSearchValue = encodeURIComponent(searchValue);
    apiUrl += `&searchValue=${encodedSearchValue}`;
  }

  if (startDate && endDate) {
    apiUrl += `&startDate=${startDate}&endDate=${endDate}`;
  }

  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createSupportTicketAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/support-ticket/add-ticket", data)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getSupportTicketById = async (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/support-ticket/detail/${id}`)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateSupportTicketStatusAction = async (data, isFormData = false) => {
  return new Promise((resolve, reject) => {
    const config = isFormData ? {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    } : {};

    // For FormData, send directly without wrapping in { data }
    const payload = isFormData ? data : { data };

    axios
      .post(`/api/support-ticket/status`, payload, config)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
};

export const deleteMultipleSupportTicketAction = async (deleteId) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/support-ticket/delete-support-ticket`, deleteId)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const addSupportTicketCommentAction = (commentData) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/support-ticket/add-comment`, commentData)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const passToAdminAction = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/support-ticket/pass-to-admin/${id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
